export const HOME_CASUAL = 'home_casual'; // 首页轮播图
export const CATEGORY_LIST = 'category_list'; // 首页轮播图
export const HOME_SHOP_LIST = 'home_shop_list'; // 首页商品数据
export const RECOMMEND_SHOP_LIST = 'recommend_shop_list'; // 推荐商品数据
export const GOODS_DETAIL = 'goods_detail'; // 获取商品详细信息
export const GOODS_COMMENT = 'goods_comment'; // 获取商品评论
export const USER_INFO = 'user_info'; // 同步用户信息
export const RESET_USER_INFO = 'reset_user_info'; // 清空用户信息
export const CART_GOODS_LIST = 'cart_goods_list'; // 购物车数据
export const CHANGE_GOODS_COUNT = 'change_goods_count'; // 改变购物车单个物品的数量
export const SELECTED_ALL_GOODS = 'selected_all_goods'; // 是否选中所有商品
export const SELECTED_SINGLE_GOODS = 'selected_single_goods'; // 是否选中单个商品
export const DEL_SINGLE_GOODS = 'del_single_goods'; // 是否删除单个商品
export const DEL_ALL_GOODS = 'del_all_goods'; // 是否删除所有商品
export const SEARCH_KEYWORDS = 'search_goods'; // 关键词搜索
export const SELECTED_CART_GOODS_LIST = 'selected_cart_goods_list'; // 已选中要下单的商品




// WEBPACK FOOTER //
// ./src/store/mutation-types.js